var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.0352C0 31.0809 8.95431 40.0352 20 40.0352C31.0457 40.0352 40 31.0809 40 20.0352C40 8.98946 31.0457 0.0351562 20 0.0351562C8.95431 0.0351562 0 8.98946 0 20.0352Z",
    fill: "#550080",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 20.0352C30 14.5352 25.5 10.0352 20 10.0352C14.5 10.0352 10 14.5352 10 20.0352C10 25.0352 13.625 29.1602 18.375 29.9102V22.9102H15.875V20.0352H18.375V17.7852C18.375 15.2852 19.875 13.9102 22.125 13.9102C23.25 13.9102 24.375 14.1602 24.375 14.1602V16.6602H23.125C21.875 16.6602 21.5 17.4102 21.5 18.1602V20.0352H24.25L23.75 22.9102H21.375V30.0352C26.375 29.2852 30 25.0352 30 20.0352Z",
    fill: "#550080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/Fb.a246ae9813e93a01d61da1a35fa4f0c4.svg";
export { ForwardRef as ReactComponent };